import fetchJSON from 'util/fetchJSON';
import { getCSRF } from '../../application/util/rails';

const milliseconds_between_checks = 24 * 60 * 60 * 1000;

const setup = () => {
  window.addEventListener('focus', () => {
    checkRelease();
  });
};

const resetLastReleaseCheck = () => {
  sessionStorage.setItem('last_release_check', Date.now());
};

const checkRelease = async () => {
  if (!window.current_user) {
    return;
  }

  const last_release_check = sessionStorage.getItem('last_release_check');

  if (Date.now() - last_release_check > milliseconds_between_checks) {
    try {
      const response = await fetchJSON('/explorer/release_check');

      if (response.refresh_mixpanel_identity) {
        await refreshMixpanelIdentity();
      }

      resetLastReleaseCheck();
    } catch (error) {
      console.log('Error while checking current release: ' + error.message);
    }
  }
};

async function refreshMixpanelIdentity() {
  return fetch('/explorer/identify', {
    method: 'POST',
    headers: {
      'X-CSRF-Token': getCSRF()
    }
  });
}

export { setup };
